import { useEffect } from "react";

import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import { UserType } from "types/user";
import { RootState } from "store/store";
import { axios } from "services/baseAxios";
import { storeName } from "store/model/app.model";
import { getRedirectUrl, getRefreshToken } from "utils/storage";
import {
  authorize,
  getToken,
  redirectUri,
  refreshToken,
  responseType,
} from "services/auth";

const responseTypeDataKeys = {
  code: "code",
  token: "access_token",
};

const useAuth = (): { user: UserType; isAuthenticated: boolean } => {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.app.user);
  const userDispatch = useDispatch()[storeName];

  const getUser = () => {
    userDispatch
      .getUserDetailAsync()
      .then((userResult: any) => {
        if (!userResult) {
          authorize();
        } else {
          const redirectUrl = getRedirectUrl();
          if (redirectUrl) {
            const url = new URL(redirectUrl);
            navigate(`${url.pathname}${url.search}`);
          }
        }
      })
      .catch((err: Error) => {
        console.error("useAuth:", err);
        const refresh = getRefreshToken();
        if (!refresh) {
          authorize();
        } else {
          refreshToken({ onSuccess: getUser });
        }
      });
  };

  useEffect(() => {
    if (!user) {
      if (window.location.href.indexOf(redirectUri ?? "") !== -1) {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        const responseKey = responseTypeDataKeys[responseType];

        getToken({ code: params.get(responseKey) ?? "", onSuccess: getUser });
        return;
      }
      axios.setToken?.();
      getUser();
    }
  }, []);

  return { user, isAuthenticated: !!user };
};

export default useAuth;
